import {useCallback, useRef} from 'react';

export const useCallbackRef = (fn, deps = []) => {
  const ref = useRef(fn);
  ref.current = fn;
  return useCallback((...args) => ref.current?.(...args), deps);
};
